import { useState } from 'react';
import { Control, UseFormHandleSubmit, UseFormReset } from 'react-hook-form';
import { IForm } from '../NewRequestPopUp';
import { DateController } from './DateController';
import { VacationTypeController } from './VacationTypeController';
import { CommentController } from './CommentController';
import { ButtonContainer } from './ButtonContainer';
import { RequestHeader } from './RequestHeader';
import {
  DateContainer,
  FieldsContainer,
  FormStyle,
} from './styles/NewRequestForms.styled';
import { EmployeeVacationDays } from '../../../../tabs/models/SummaryInterfaces';

interface NewRequestFormProps {
  control: Control<IForm>;
  handleSubmit: UseFormHandleSubmit<IForm, undefined>;
  submitHandler: (data: IForm) => void;
  hidePopup: () => void;
  reset: UseFormReset<IForm>;
  holidays: Array<string>;
  vacationPeriodNextYear: EmployeeVacationDays;
  selectedYear: number;
  mappedVacationTypes: {
    key: string;
    text: string;
  }[];
}

export const NewRequestForm = ({
  control,
  handleSubmit,
  submitHandler,
  hidePopup,
  reset,
  holidays,
  vacationPeriodNextYear,
  selectedYear,
  mappedVacationTypes,
}: NewRequestFormProps) => {
  const [startDate, setStartDate] = useState<Date>();

  return (
    <FormStyle onSubmit={handleSubmit(submitHandler)}>
      <RequestHeader />
      <FieldsContainer>
        <DateContainer>
          <DateController
            holidays={holidays}
            control={control}
            setStartDate={setStartDate}
            dateLabel="Start Date"
            controllerName="startDate"
            vacationPeriodNextYear={vacationPeriodNextYear}
            selectedYear={selectedYear}
          />
          <DateController
            holidays={holidays}
            control={control}
            startDate={startDate}
            dateLabel="End Date"
            controllerName="endDate"
            vacationPeriodNextYear={vacationPeriodNextYear}
            selectedYear={selectedYear}
            disabled={!startDate}
          />
        </DateContainer>
        <VacationTypeController
          control={control}
          mappedVacationTypes={mappedVacationTypes}
        />
        <CommentController control={control} />
        <ButtonContainer hidePopup={hidePopup} reset={reset} />
      </FieldsContainer>
    </FormStyle>
  );
};
